import { Box } from '@mui/material';
import {
  ResponseDataHandle,
  ListPlaceholder,
  ErrorList,
  EmptyData,
} from '@/components/common';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';
import { Vendor } from '@/@types/vendor';
import { VendorsTable } from '../VendorsTable';
import { VendorsTableColumns } from '../VendorsTable/VendorTableColumns';

type TVendorsData = {
  vendors: Vendor[];
  totalCount: number;
};

interface IVendorsListProps {
  isLoading: boolean;
  isError: boolean;
  data: TVendorsData | undefined;
  sort?: 'desc' | 'asc';
  sortBy?: keyof Vendor;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: object;
  pagination?: ITablePaginationProps;
}

export function VendorsList({
  isLoading,
  isError,
  data,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: IVendorsListProps) {
  return (
    <ResponseDataHandle
      isLoading={isLoading}
      loadingComponent={
        <ListPlaceholder
          headers={[
            'Nome',
            'CPF/CNPJ',
            'RG/Inscrição Estadual',
            'Criado em',
            'Ações',
          ]}
        />
      }
      isError={isError}
      errorComponent={
        <Box py={10}>
          <ErrorList text="Falha ao obter os dados dos fornecedores." />
        </Box>
      }
      totalItems={data?.totalCount}
      emptyComponent={
        <Box py={10}>
          <EmptyData />
        </Box>
      }
    >
      <VendorsTable
        columns={VendorsTableColumns}
        data={data?.vendors || []}
        sort={sort}
        sortBy={sortBy}
        onSort={onSort}
        actions={actions}
        pagination={pagination}
      />
    </ResponseDataHandle>
  );
}
